/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentCaptureField } from './documentCaptureField';


export interface DocumentCaptureIdentityDocument { 
    code?: DocumentCaptureIdentityDocument.CodeEnum;
    name?: string;
    serialType?: string;
    additionalDocumentTypes?: Array<DocumentCaptureIdentityDocument.AdditionalDocumentTypesEnum>;
    fields?: Array<DocumentCaptureField>;
}
export namespace DocumentCaptureIdentityDocument {
    export type CodeEnum = 'ID_CARD' | 'ELECTRONIC_ID_CARD' | 'DRIVING_LICENSE' | 'FISCAL_CODE' | 'PASSPORT' | 'SELFIE';
    export const CodeEnum = {
        IdCard: 'ID_CARD' as CodeEnum,
        ElectronicIdCard: 'ELECTRONIC_ID_CARD' as CodeEnum,
        DrivingLicense: 'DRIVING_LICENSE' as CodeEnum,
        FiscalCode: 'FISCAL_CODE' as CodeEnum,
        Passport: 'PASSPORT' as CodeEnum,
        Selfie: 'SELFIE' as CodeEnum
    };
    export type AdditionalDocumentTypesEnum = 'ID_CARD' | 'ELECTRONIC_ID_CARD' | 'DRIVING_LICENSE' | 'FISCAL_CODE' | 'PASSPORT' | 'SIGNATURE_SPECIMEN' | 'SELFIE';
    export const AdditionalDocumentTypesEnum = {
        IdCard: 'ID_CARD' as AdditionalDocumentTypesEnum,
        ElectronicIdCard: 'ELECTRONIC_ID_CARD' as AdditionalDocumentTypesEnum,
        DrivingLicense: 'DRIVING_LICENSE' as AdditionalDocumentTypesEnum,
        FiscalCode: 'FISCAL_CODE' as AdditionalDocumentTypesEnum,
        Passport: 'PASSPORT' as AdditionalDocumentTypesEnum,
        SignatureSpecimen: 'SIGNATURE_SPECIMEN' as AdditionalDocumentTypesEnum,
        Selfie: 'SELFIE' as AdditionalDocumentTypesEnum
    };
}


